import type {
  CampoPacienteConfiguracionKey,
  IPacientesConfiguracionCampos,
  IPacienteCampoConfiguracionDefinicion
} from '@/modules/Administracion/interfaces/IPacientesConfiguracion'

export const CODIGO_CONFIGURACION_PACIENTES = 'CONFIG_FORMULARIO_PACIENTES'
export const CATEGORIA_CONFIGURACION_PACIENTES = 'Pacientes'

export const camposPacienteConfigurables: IPacienteCampoConfiguracionDefinicion[] =
  [
    {
      clave: 'copnNombre1',
      etiqueta: 'Primer nombre',
      tipoDato: 'texto',
      requeridoPorDefecto: true
    },
    {
      clave: 'copnNombre2',
      etiqueta: 'Segundo nombre',
      tipoDato: 'texto',
      requeridoPorDefecto: false
    },
    {
      clave: 'copnApellido1',
      etiqueta: 'Primer apellido',
      tipoDato: 'texto',
      requeridoPorDefecto: true
    },
    {
      clave: 'copnApellido2',
      etiqueta: 'Segundo apellido',
      tipoDato: 'texto',
      requeridoPorDefecto: false
    },
    {
      clave: 'coppFechanacimiento',
      etiqueta: 'Fecha de nacimiento',
      tipoDato: 'fecha',
      requeridoPorDefecto: true
    },
    {
      clave: 'copeTelefono',
      etiqueta: 'Número de celular',
      tipoDato: 'texto',
      requeridoPorDefecto: true
    },
    {
      clave: 'copeTelalternativo',
      etiqueta: 'Número de celular alternativo',
      tipoDato: 'texto',
      requeridoPorDefecto: false
    },
    {
      clave: 'copeEmail',
      etiqueta: 'Email',
      tipoDato: 'texto',
      requeridoPorDefecto: false
    },
    {
      clave: 'copeDireccion',
      etiqueta: 'Dirección',
      tipoDato: 'texto',
      requeridoPorDefecto: true
    },
    {
      clave: 'coppTipoBarrio',
      etiqueta: 'Barrio',
      tipoDato: 'texto',
      requeridoPorDefecto: true
    },
    {
      clave: 'copeTipoDivipola',
      etiqueta: 'Lugar de residencia',
      tipoDato: 'seleccion',
      requeridoPorDefecto: true,
      opciones: 'divipola',
      usarSelectSearch: true
    },
    {
      clave: 'coppTipoDivipola',
      etiqueta: 'Lugar de nacimiento',
      tipoDato: 'seleccion',
      requeridoPorDefecto: true,
      opciones: 'divipola',
      usarSelectSearch: true
    },
    {
      clave: 'coppTipoZona',
      etiqueta: 'Zona',
      tipoDato: 'seleccion',
      requeridoPorDefecto: true,
      opciones: 'tipozona',
      usarSelectDefault: true
    },
    {
      clave: 'coppTipoNiveleducativo',
      etiqueta: 'Educación',
      tipoDato: 'seleccion',
      requeridoPorDefecto: true,
      opciones: 'tiponvleducacion',
      usarSelectDefault: true
    },
    {
      clave: 'coppTipoOcupacion',
      etiqueta: 'Ocupación',
      tipoDato: 'seleccion',
      requeridoPorDefecto: false,
      opciones: 'tipoocupacion',
      usarSelectSearch: true
    },
    {
      clave: 'coppTipoSexo',
      etiqueta: 'Sexo',
      tipoDato: 'seleccion',
      requeridoPorDefecto: true,
      opciones: 'tiposexo',
      usarSelectDefault: true
    },
    {
      clave: 'coppTipoGenero',
      etiqueta: 'Género',
      tipoDato: 'seleccion',
      requeridoPorDefecto: true,
      opciones: 'tipogenero',
      usarSelectDefault: true
    },
    {
      clave: 'coppTipoOrientacion',
      etiqueta: 'Orientación sexual',
      tipoDato: 'seleccion',
      requeridoPorDefecto: false,
      opciones: 'tipoorientacion',
      usarSelectSearch: true
    },
    {
      clave: 'coppTipoEstadocivil',
      etiqueta: 'Estado civil',
      tipoDato: 'seleccion',
      requeridoPorDefecto: false,
      opciones: 'tipoestadocivil',
      usarSelectDefault: true
    },
    {
      clave: 'coppTipoPoblacion',
      etiqueta: 'Población principal',
      tipoDato: 'seleccion',
      requeridoPorDefecto: false,
      opciones: 'tipopoblacion',
      usarSelectSearch: true
    },
    {
      clave: 'coppTipoListPoblaciones',
      etiqueta: 'Población adicional (separada por comas)',
      tipoDato: 'texto',
      requeridoPorDefecto: false
    },
    {
      clave: 'coppTipoEtnia',
      etiqueta: 'Etnia',
      tipoDato: 'seleccion',
      requeridoPorDefecto: false,
      opciones: 'tipoetnia',
      usarSelectSearch: true
    },
    {
      clave: 'coppTipoIncapacidad',
      etiqueta: 'Discapacidad',
      tipoDato: 'seleccion',
      requeridoPorDefecto: false,
      opciones: 'tipoincapacidad',
      usarSelectSearch: true
    },
    {
      clave: 'coppTipoEstado',
      etiqueta: 'Estado del paciente',
      tipoDato: 'texto',
      requeridoPorDefecto: false,
      valorPorDefectoPorDefecto: 'ACTIVO',
      opciones: 'tipoestado',
      usarSelectDefault: true
    }
  ]

export const crearConfiguracionCamposPaciente =
  (): IPacientesConfiguracionCampos =>
    Object.fromEntries(
      camposPacienteConfigurables.map(campo => [
        campo.clave,
        {
          requerido: campo.requeridoPorDefecto,
          oculto: false,
          valorPorDefecto: campo.valorPorDefectoPorDefecto ?? ''
        }
      ])
    ) as IPacientesConfiguracionCampos

export const normalizarConfiguracionCamposPaciente = (
  valor: string | null | undefined
): IPacientesConfiguracionCampos => {
  const configuracion = crearConfiguracionCamposPaciente()
  if (!valor) return configuracion

  try {
    const guardado = JSON.parse(valor) as {
      campos?: Partial<
        Record<
          CampoPacienteConfiguracionKey,
          Partial<IPacientesConfiguracionCampos[CampoPacienteConfiguracionKey]>
        >
      >
    }

    if (!guardado.campos) return configuracion

    for (const campo of camposPacienteConfigurables) {
      const guardadoCampo = guardado.campos[campo.clave]
      if (!guardadoCampo) continue

      configuracion[campo.clave] = {
        requerido:
          typeof guardadoCampo.requerido === 'boolean'
            ? guardadoCampo.requerido
            : campo.requeridoPorDefecto,
        oculto:
          typeof guardadoCampo.oculto === 'boolean'
            ? guardadoCampo.oculto
            : false,
        valorPorDefecto:
          guardadoCampo.valorPorDefecto === null ||
          guardadoCampo.valorPorDefecto === undefined
            ? (campo.valorPorDefectoPorDefecto ?? '')
            : String(guardadoCampo.valorPorDefecto)
      }
    }
  } catch {
    return crearConfiguracionCamposPaciente()
  }

  return configuracion
}

export const serializarConfiguracionCamposPaciente = (
  campos: IPacientesConfiguracionCampos
): string => JSON.stringify({ version: 1, campos })
